export default (state = [], action) => {
  //console.log(state, action);
  // if(action.type === ) {
  //   let modal = state.modal;
  //   state = { modal, ...action.payload}
  // }

  return state;
};
